import * as Sentry from "@sentry/react";
import { propagationContextFromHeaders } from "@sentry/core";
import getSentryConfig from "./sentryConfig";
import patchFetchForSentryTrace from "./sentryTraceFetch";

function debugLog(...msgArr) {
  if (window.LOCAL_DEV) {
	console.debug(...msgArr);
  }
}

if (window.SENTRY_DSN) {
  const config = getSentryConfig(Sentry)
  if (!Sentry.getClient()) {
	Sentry.init(config);
	Sentry.getCurrentScope().setPropagationContext(
	  propagationContextFromHeaders(window.SENTRY_TRACE, window.SENTRY_BAGAGGE)
	);
	patchFetchForSentryTrace(Sentry);
	debugLog("Initialized Sentry with", config, Sentry);
  }
} else if (!window.LOCAL_DEV) {
  console.warn("Sentry error logging disabled");
}
export { Sentry };
